export default myMeterCtrl

/** @ngInject */
function myMeterCtrl($scope, $state) {
    $scope.isActive = (state) => state === $state.current.name
}



// WEBPACK FOOTER //
// ./src/states/myMeter/controller.js